var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthWrapper',{attrs:{"title":_vm.$t('title.setNewPassword')},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('AuthBackToLogin')]},proxy:true}])},[_c('ResetPasswordForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }